import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import {
  getZeroCarbonProjects,
  getZeroCarbonProjectsAsSelect,
} from '~/services/ZeroCarbon';
import { Pagination, SelectItem } from '~/types';
import { PAGE_SIZE } from '~/constants';
import { ZeroCarbonProject, ZeroCarbonProjectView } from '~/types/zeroCarbon';

export function useZeroCarbonProjects(
  page: number,
  size = PAGE_SIZE,
  options: UseQueryOptions<Pagination<ZeroCarbonProjectView>, unknown> = {},
): UseQueryResult<Pagination<ZeroCarbonProjectView>, unknown> {
  return useQuery<Pagination<ZeroCarbonProjectView>, unknown>(
    ['zero_carbon_projects', page],
    () => getZeroCarbonProjects(page, size),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}

export function useZeroCarbonProjectsAsSelect(
  options: UseQueryOptions<SelectItem[], unknown> = {},
): UseQueryResult<SelectItem[], unknown> {
  return useQuery<SelectItem[], unknown>(
    'zero_carbon_projects_as_select',
    () => getZeroCarbonProjectsAsSelect(),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}
